/**
 * Enum representing different types of templates.
 */
export enum TemplateTypeEnum {
  /** On-site VKA template. */
  VKA_Vorlage = "on_stie_vka",
  /** Laboratory VKA template. */
  Labor_VKA = "laboratory_vka",
  /** Microbiological examination template. */
  Mikrobiologische = "microbiological_examination",
  /** Visit template. */
  Besuch = "visit_template",
  /** Monthly microbiological examination template. */
  MicrobiologicalMonthly = "microbiological_examination_monthly",
  /** High colony microbiological template. */
  HighColony = "high_colony_microbiological_template",
  /** High legionella microbiological template. */
  HighLegionella = "high_legionella_microbiological_template",
  /** High pseudomonas microbiological template. */
  HighPseudomona = "high_pseudomonas_microbiological_template",
  /** Maintenance template. */
  Wartung_Inspektion = "maintenance_template",
  /** Microbiological examination 2 template. */
  MicrobiologicalExamination2 = "microbiological_examination_2",
  /** Order handling template. */
  OrderHandling = "order_handling",
  /** Order handling IW template. */
  OrderHandlingIW = "order_handling_iw",
  /** Plant startup template. */
  PlantStartup = "plant_startup",
  /** Action taken template. */
  ActionTaken = "action_taken",
  /** Legionella examination template. */
  LegionellaExamination = "legionella_examination",
  /** Heavy metal examination template. */
  HeavyMetalExamination = "heavy_metal_examination",
  /** Microbiological analysis DW template. */
  MicrobiologicalAnalysisDW = "microbiological_analysis_dw",
  /** Checkliste Trinkwasser - the 4-phase drinking water checklist. */
  DrinkingWaterChecklist = "drinking_water_checklist",
  /** Pre-startup template. */
  PlantPreStartUp = "plant_pre_startup",
  //These types act as VOA
  InternalOperationalInspection = "internal_operational_inspection",
  BoilerWaterAnalysis = "boiler_water_analysis",
  ChlorineDioxideMeasurement = "chlorine_dioxide_measurement",
  ProcessWaterMeasurement ="process_water_measurement",
  BIPPlus ="bip_plus",
  /** Monthly maintenance (Monatliche Wartung). */
  MonthlyMaintenance = "monthly_maintenance",
  /** Quarterly inspection (Vierteljährliche Inspektion). */
  QuarterlyInspection = "quarterly_inspection",
  /** Yearly inspection (Jahresinspektion). */
  YearlyInspection = "yearly_inspection",

  BiWeeklyAnalysis = "bi_weekly_analysis",
  /** Weekly on-site analysis (Wöchentliche Analyse), started by a critical Legionella result. */
  WeeklyAnalysis = "weekly_analysis",
  /** Legionella group determination (Legionellengruppenbestimmung), the re-sample of a critical result. */
  LegionellaGroupDetermination = "legionella_group_determination",
}

/**
 * Template types that behave like a maintenance/inspection task: the legacy
 * "Wartung/Inspektion" type plus the three frequency-specific types. Used to gate
 * maintenance-specific UI (maintenance template section, form rendering, etc.).
 */
export const MAINTENANCE_TEMPLATE_TYPES: TemplateTypeEnum[] = [
  TemplateTypeEnum.Wartung_Inspektion,
  TemplateTypeEnum.MonthlyMaintenance,
  TemplateTypeEnum.QuarterlyInspection,
  TemplateTypeEnum.YearlyInspection,
];

/**
 * Whether the given template type key is one of the maintenance-like templates.
 */
export const isMaintenanceTemplateType = (
  key?: TemplateTypeEnum | string | null
): boolean => MAINTENANCE_TEMPLATE_TYPES.includes(key as TemplateTypeEnum);

/**
 * Enum representing different types of maintenance schedules.
 */
export enum MaintenanceTypeEnum {
  /** Monthly control maintenance. */
  monthly = "monthly_control",
  /** Quarterly control maintenance. */
  quarterly = "quarterly_control",
  /** Semi-annual control maintenance. */
  semi_annual = "semi_annual_control"
}

export const ON_SITE_TEMPLATE_TYPES: TemplateTypeEnum[] = [
  TemplateTypeEnum.VKA_Vorlage,
  TemplateTypeEnum.InternalOperationalInspection,
  TemplateTypeEnum.BIPPlus,
  TemplateTypeEnum.ChlorineDioxideMeasurement,
  TemplateTypeEnum.ProcessWaterMeasurement,
  TemplateTypeEnum.BoilerWaterAnalysis,
  TemplateTypeEnum.WeeklyAnalysis,
];

export const isOnSiteTemplateType = (key?: TemplateTypeEnum | string | null
): boolean => ON_SITE_TEMPLATE_TYPES.includes(key as TemplateTypeEnum);
